<template>
	<div class="pay-result-page">
		<nio-header-nav
			position="fixed"
			:height.sync="headerHeight"
			leftButton="close"
			@back="handleClose"
			:is-white="true"
		/>
		<p class="page-title" :style="{ paddingTop: headerHeight + 10 + 'px' }">
			{{ isSuccess ? '支付成功' : '支付失败' }}
		</p>
		<p class="page-subtitle">
			{{ isSuccess ? '订单支付成功' : '订单还没有付款，您可以选择其他支付方式' }}
		</p>

		<div class="img-container">
			<img :src="isSuccess ? paySuccessImg : payFailImg" />
		</div>
		<div
			class="bottom-area"
			:style="{ bottom: safeAreaInsetBottom ? safeAreaInsetBottom + 'px' : px2vw(15) }"
		>
			<nio-button v-if="isSuccess" @click="goToOrderDetail">查看订单</nio-button>
			<nio-button v-else @click="handleClose">重新支付</nio-button>
		</div>
	</div>
</template>

<script>
import payFailImg from '@/assets/svg/pay_fail.svg'
import paySuccessImg from '@/assets/svg/pay_success.svg'
import { supreme } from '@/supreme-core'
import { getSafeInsetBottom, px2vw } from '@/util/unit-transfer'
import nativeHybrid from '@/util/nativeHybrid'
import link from '@/util/link'

export default {
	name: 'Index',
	data() {
		return {
			payFailImg,
			paySuccessImg,

			headerHeight: 0,

			isSuccess: supreme.getQueryString('success') === 'true',
			safeAreaInsetBottom: getSafeInsetBottom(),
			px2vw,
			orderNo: supreme.getQueryString('order_no')
		}
	},
	methods: {
		handleClose() {
			nativeHybrid.closeSyn()
		},
		goToOrderDetail() {
			link.goToRoute(
				'/order-detail',
				{
					order_no: this.orderNo
				},
				true
			)

			// setTimeout(() => {
			// 	nativeHybrid.closeSyn()
			// }, 500)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.pay-result-page {
	padding-left: 20px;
	padding-right: 20px;

	.page-title {
		@include headline_1(1.3, 400, false);
		margin-bottom: 10px;
		color: $text_primary;
	}
	.page-subtitle {
		@include subtitle_3(1.5, 400, false);
		color: $text_primary;
	}

	.img-container {
		margin-top: 105px;
		width: 335px;
		height: 335px;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	.bottom-area {
		position: fixed;
		left: 20px;
		right: 20px;
	}
}
</style>
